export const delay = (delayTime: number) => new Promise<void>((resolve) => {
  setTimeout(resolve, delayTime);
});
